var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-container',{attrs:{"columns":_vm.columns,"data":_vm.items,"actions":_vm.actions,"titleKey":"ClientName","headerActitonStyle":_vm.headerActitonStyle},on:{"loadMore":function($event){return _vm.$emit('loadMore')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }